module.exports = __webpack_public_path__ + "media/images/emblems/Buehler-coat_of_arms-fdc70f80e4520b61a13f64a31c843796.svg";